import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CatalogoModel } from '../_models/bin-catalogos.model';
import { ZeroService } from './zero/zero.service';
import {  REST_SERVICES } from './settings'; 
import { BehaviorSubject, Observable } from 'rxjs';
import { ListaCatalogosModel } from '../_models/bin-lista-catalogos.model';

@Injectable()
export class CatalogosService {
    //public catalogos: Array<CatalogoModel>;
    private listaCatalogos:ListaCatalogosModel;
private s: CatalogoModel
    constructor(private zeroService: ZeroService,
        private http: HttpClient) { 
            this.listaCatalogos = new ListaCatalogosModel();
    }

    
    // getCatalogos(): Observable<ListaCatalogosModel>{
    //   return this.listaCatalogos.asObservable();
    // }
 
    buscarCatalogos( funOK:Function,funError:Function  ) {
        let scope = this;
        let catalogosLista = new  ListaCatalogosModel();
        scope.zeroService.request({
            uri: REST_SERVICES.search_catalogos,
            isSingleResponse: false,
            method: "GET",
            ok: function (response) {
                let catalogos = response.response; 
                let acciones: Array<any> = catalogos.lstCatAccionEstat;
                if (catalogos) {
                    
                    acciones.forEach(x => {
                        catalogosLista.lstCatAccionEstat.push({
                            id: x.idAccionEstatPk,
                            clave: x.clave,
                            descripcion: x.nombre,
                            soporteCash: x.soportecash,
                            cashCredito: x.cashcredito
                        });
                    });
                    let bancos: Array<any> = catalogos.lstCatBancos;
                    bancos.forEach(x => {
                        catalogosLista.lstCatBancos.push({
                            id: x.id,
                            clave: '',
                            descripcion: x.nombre,
                            soporteCash: x.soportecash,
                            cashCredito: x.cashcredito
                        });
                    });
                    let bancosPro: Array<any> = catalogos.lstCatBancosProsa;
                    bancosPro.forEach(x => {
                        catalogosLista.lstCatBancosProsa.push({
                            id: x.idBancoProsaPk,
                            clave: '',
                            descripcion: x.nombrBanco,
                            soporteCash: x.soportecash,
                            cashCredito: x.cashcredito
                        });
                    });
                    let bancosEGlobal: Array<any> = catalogos.lstCatEGlobalBancos;
                    bancosEGlobal.forEach(x => {
                        catalogosLista.lstCatEGlobalBancos.push({
                            id: x.idEglobalBancosPk,
                            clave: '',
                            descripcion: x.nombrEglobalBanco,
                            soporteCash: x.soportecash,
                            cashCredito: x.cashcredito
                        });
                    });
                    let binEstat: Array<any> = catalogos.lstCatBinEstat;
                    binEstat.forEach(x => {
                        catalogosLista.lstCatBinEstat.push({
                            id: x.idBinEstatPk,
                            clave: '',
                            descripcion: x.nombreEstat,
                            soporteCash: x.soportecash,
                            cashCredito: x.cashcredito
                        });
                    });
                    let productos: Array<any> = catalogos.lstCatProdu;
                    productos.forEach(x => {
                        catalogosLista.lstCatProdu.push({
                            id: x.idProduPk,
                            clave: x.claveProd,
                            descripcion: x.nombreProd,
                            soporteCash: x.soportecash,
                            cashCredito: x.cashcredito
                        });
                    });

                    let tipoBines: Array<any> = catalogos.lstCatTipoBines;
                    tipoBines.forEach(x => {
                        catalogosLista.lstCatTipoBines.push({
                            id: x.idTipoBinesPk,
                            clave: '',
                            descripcion: x.nombrTipo,
                            soporteCash: x.soportecash,
                            cashCredito: x.cashcredito
                        });
                    });
                }
                // scope.listaCatalogos.next(catalogosLista);
                scope.listaCatalogos = catalogosLista;
               // siguiente( scope.listaCatalogos ); 
                if(funOK){
                    funOK(scope.listaCatalogos);
                } 
            },
            error:function (response) { 
                funError(response);
            }

        });
    }


}
